import React, { useEffect, useState } from 'react';
import { Container, Button, Box, Link, Typography } from '@mui/material';
import Input from '../../components/Input';
import logoBlue from '../../assets/images/logo-blue.svg';
import { recoverPasswordSendMail } from '../../services/users.js';
import { useAlert } from '../../context';
import { AlertError, AlertSuccess } from '../../components/Alerts';

import './index.scss';

const SendTokenPasswordForm = () => {
  const [mobileView, setMobileView] = useState(false);
  const [email, setEmail] = useState('');

  const { setShowSuccess, setShowError } = useAlert();

  useEffect(() => {
    const setResponsiveness = () => {
      return window.innerWidth < 600 ? setMobileView(true) : setMobileView(false);
    };

    setResponsiveness();
    window.addEventListener('resize', () => setResponsiveness());

    return () => {
      window.removeEventListener('resize', () => setResponsiveness());
    };
  }, []);

  const handleSendTokenPasswordForm = e => {
    e.preventDefault();
    recoverPasswordSendMail(email).then(
      response => {
        setShowSuccess(true);
      },
      error => {
        setShowError(true);
      }
    );
  };

  return (
    <Box
      sx={{
        margin: '0 auto',
        width: '100%',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          width: '100%',
          minHeight: '100vh',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: 'primary.main',
          '@media (max-width: 600px)': {
            backgroundColor: 'transparent',
          },
        }}
        className={mobileView ? '' : 'border-blue'}
      >
        <Box
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'space-between',
            overflow: 'hidden',
            width: '100%',
            minHeight: '600px',
            '@media (max-width: 600px)': {
              backgroundColor: 'white',
              minHeight: '100vh',
            },
          }}
        >
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              flexGrow: 1,
              backgroundColor: 'secondary.main',
              '@media (max-width: 600px)': {
                maxHeight: '200px',
              },
            }}
            className="logo-blue-container"
          >
            <img src={logoBlue} alt="Logo da empresa HWater" />
          </Box>
          <Box
            sx={{
              padding: '50px 0',
              backgroundColor: 'white',
              flexGrow: 1,
              '@media (max-width: 680px)': {
                paddingBottom: '50%',
              },
            }}
          >
            <Container
              component="main"
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                margin: 'auto',
                height: '100%',
              }}
            >
              <Box
                component="section"
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  width: '80%',
                  maxWidth: '500px',
                }}
              >
                <Typography variant="h4" sx={{ color: '#41474D', textAlign: 'center' }}>
                  Redefina sua senha
                </Typography>
                <Typography
                  variant="body1"
                  sx={{ margin: '15px 0 0', textAlign: 'center', color: '#41474D' }}
                >
                  Sem problemas! Nós encaminharemos um e-mail com as instruções para que
                  você possa redefinir sua senha.
                </Typography>
              </Box>
              <Box
                component="form"
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-between',
                  margin: '30px 0',
                  height: '150px',
                  width: '65%',
                  maxWidth: '350px',
                  '@media (max-width: 1220px)': {
                    width: '75%',
                  },
                  '@media (max-width: 1990px)': {
                    width: '85%',
                  },
                  '@media (max-width: 900px)': {
                    maxWidth: '400px',
                    width: '90%',
                  },
                  '@media (max-width: 600px)': {
                    maxWidth: '400px',
                    width: '95%',
                  },
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    margin: '10px 0',
                    width: '100%',
                  }}
                >
                  <Input
                    required
                    type="email"
                    id="email"
                    label="Email"
                    name="Email"
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                  />
                </Box>
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    width: '100%',
                  }}
                >
                  <Button
                    type="submit"
                    variant="contained"
                    className="btns"
                    onClick={handleSendTokenPasswordForm}
                    sx={{
                      alignSelf: 'center',
                      fontWeight: 600,
                      width: '250px',
                      height: '44px',
                      borderRadius: '10px',
                      margin: '10px',
                      backgroundColor: 'primary.main',
                    }}
                  >
                    Recuperar senha
                  </Button>
                  <Typography variant="body1">
                    <Link href="/">Voltar para login</Link>
                  </Typography>
                </Box>
              </Box>
              <AlertError textAlert={'Usuário não encontrado.'} />
              <AlertSuccess textAlert={'E-mail de recuperação de senha enviada!'} />
            </Container>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default SendTokenPasswordForm;
